import { makeStyles, TableCell, TableRow, Theme } from '@material-ui/core'
import React from 'react'

type StyleProps = {
  showBorder?: boolean
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  tableCellLeft: {
    paddingLeft: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderBottom: (props) => (props.showBorder ? undefined : 0),
  },
  tableCellRight: {
    paddingRight: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderBottom: (props) => (props.showBorder ? undefined : 0),
  },
  printPadding: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

type Props = StyleProps & {
  name: string | React.ReactElement
  value: string | number | React.ReactElement
  printPadding?: boolean
}

export function SidebarAccordionTableRow({
  name,
  value,
  showBorder,
  printPadding,
}: Props): React.ReactElement {
  const classes = useStyles({ showBorder })

  return (
    <TableRow>
      <TableCell
        className={printPadding ? classes.printPadding : classes.tableCellLeft}
      >
        {name}
      </TableCell>
      <TableCell
        align="right"
        className={printPadding ? classes.printPadding : classes.tableCellRight}
      >
        {value}
      </TableCell>
    </TableRow>
  )
}
